import Env from '@/common/constants/Env.json'
import EnvStage from '@/common/constants/Env_stage.json'
import EnvProd from '@/common/constants/Env_prod.json'
import Util from '@/common/utils/Util'

let CODE_ENV_LIST = Env

if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = EnvProd
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage
}

CODE_ENV_LIST = EnvProd

const USER_KCB__AUTH_TYPE = {
  'CID': { name: 'CID', value: 1, label: '신용카드' },
  'IDS': { name: 'IDS', value: 2, label: '휴대폰' },
  'TIS': { name: 'TIS', value: 3, label: '아이핀' }
}

const ConstCode = function() {
  return {
    CODE_ENV_LIST,
    USER_KCB__AUTH_TYPE,
    getImagePath: function(path = '', type = 'origin/') {
      if (Util.isEmpty(path)) return ''
      return `${this.CODE_ENV_LIST.FILE_SERVER_URL}${type}${path}`
    },
    fnImageExpanding: function(path = '') {
      if (Util.isEmpty(path)) return false
      window.open(`${this.CODE_ENV_LIST.FILE_SERVER_URL}${path}`, '_blank')
    }
  }
}

export default ConstCode()
